__turbopack_context__.v({
  "loadingRow": "CopyUploadLinkMenuItem-module__vYk6lq__loadingRow",
  "uploadLinksContainer": "CopyUploadLinkMenuItem-module__vYk6lq__uploadLinksContainer",
});
